import { useEffect, useState } from "react";
import { generatedApi } from "src/store/api/generatedApi";
import { useIsAdmin } from "./settings";

export const useAvailableTenants = (tenantGroupName?: string) => {
  const isAdmin = useIsAdmin();
  const [availableTenants, setAvailableTenants] = useState<string[]>([]);
  const [listTenantNames] =
    generatedApi.endpoints.listTenantNames.useLazyQuery();
  useEffect(() => {
    void listTenantNames({
      tenantGroupName,
      visibility: isAdmin ? "all" : "user",
    }).then((res) => {
      setAvailableTenants(res.data?.tenant_names ?? []);
    });
  }, [listTenantNames, setAvailableTenants, isAdmin, tenantGroupName]);
  return availableTenants;
};
